module.exports = __webpack_public_path__ + "img/vintgar_13_2.2dab1020.jpg";